"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DisplayNotAvailable = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconify = require("@iconify/react/dist/iconify.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DisplayNotAvailable = exports.DisplayNotAvailable = function DisplayNotAvailable() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "notAvailable_container"
  }, /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
    icon: "fe:app-menu",
    color: "#c4c4c4",
    height: 50
  }), /*#__PURE__*/_react["default"].createElement("h5", null, "Display is not available"), /*#__PURE__*/_react["default"].createElement("p", null, "csv, xls and xlsx file displays will be ", /*#__PURE__*/_react["default"].createElement("br", null), " supported in the future"));
};